import React, { useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth, homeForRole } from '../context/AuthContext';
import { Logo } from '../components/commerce/Logo';

export default function LoginPage() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const redirect = params.get('redirect');

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    const res = await login(email, password);
    setLoading(false);
    if (res.ok) navigate(redirect || homeForRole(res.user.role));
    else setError(res.error);
  };

  return (
    <div data-testid="login-page" className="mx-auto flex max-w-[1280px] items-center justify-center px-4 py-16">
      <div className="w-full max-w-sm rounded-3xl bg-kelate-surface p-8 shadow-[0_1px_4px_rgba(81,68,55,0.08)]">
        <div className="text-center">
          <Logo className="mx-auto h-10" testId="login-logo" />
          <h1 className="mt-2 text-base font-semibold text-kelate-ink">Welcome back</h1>
          <p className="mt-1 text-xs text-kelate-soft">Log in to shop, sell or manage operations.</p>
        </div>
        <form onSubmit={submit} className="mt-6 space-y-3">
          <input data-testid="login-email" type="email" required placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} className="h-10 w-full rounded-sm border border-kelate-line bg-kelate-bg px-3 text-sm outline-none focus:border-kelate-wood" />
          <input data-testid="login-password" type="password" required placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} className="h-10 w-full rounded-sm border border-kelate-line bg-kelate-bg px-3 text-sm outline-none focus:border-kelate-wood" />
          {error && <p className="text-xs text-kelate-red" data-testid="login-error">{error}</p>}
          <button data-testid="login-submit" disabled={loading} className="h-10 w-full rounded-sm bg-kelate-darkwood text-sm font-medium text-kelate-surface hover:bg-kelate-wood disabled:opacity-50">
            {loading ? 'Logging in...' : 'Log In'}
          </button>
        </form>
        <p className="mt-4 text-center text-xs text-kelate-soft">
          New to KELATE? <Link to={`/account/register${redirect ? `?redirect=${redirect}` : ''}`} data-testid="go-register" className="font-medium text-kelate-wood hover:text-kelate-darkwood">Create account</Link>
        </p>
      </div>
    </div>
  );
}
